import { useNoSSR } from 'utils/NoSSR'
import { getPhotoBooksStore, getTilesStore } from 'stores/RootStoreProvider'
import { useMobxSelector } from 'utils/mobx/useMobxSelector'

export function useTilesInProgress() {
  const isClient = useNoSSR()
  const hasTilesInProgress = useMobxSelector(() => {
    if (!isClient) return false
    return getTilesStore().tiles.length > 0
  }, [isClient])

  return hasTilesInProgress
}

export function usePhotoBookInProgress() {
  const isClient = useNoSSR()
  const hasPhotoBookInProgress = useMobxSelector(() => {
    if (!isClient) return false
    return getPhotoBooksStore().hasAnyBook
  }, [isClient])

  return hasPhotoBookInProgress
}
